'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

/* Actions */

var _actionsAuthentication = require('actions/authentication');

var _actionsAuthentication2 = _interopRequireDefault(_actionsAuthentication);

/* Api */

var _apiAuthentication = require('api/authentication');

var _apiAuthentication2 = _interopRequireDefault(_apiAuthentication);

var _apiStatus = require('api/status');

var _apiStatus2 = _interopRequireDefault(_apiStatus);

exports['default'] = _reflux2['default'].createStore({

  listenables: [_actionsAuthentication2['default']],

  init: function init() {
    var _this = this;

    this.status = 'loading';
    this.loggedIn = false;
    this.errors = [];
    this.user = null;

    setTimeout(function () {
      _apiAuthentication2['default'].load().done(function (data) {
        if (!data) {
          window.location = '/logout';
          return;
        }

        _this.status = 'authenticated';
        _this.loggedIn = true;
        _this.user = data;

        _this.trigger({
          status: _this.status,
          loggedIn: _this.loggedIn,
          errors: _this.errors,
          user: _this.user
        });
      }).fail(function (xhr) {
        if (xhr.status === _apiStatus2['default'].UNAUTHORIZED) {
          _this.status = 'unauthenticated';
          _this.loggedIn = false;
          _this.user = null;

          _this.trigger({
            status: _this.status,
            loggedIn: _this.loggedIn,
            errors: _this.errors,
            user: _this.user
          });
        }
      });
    }, 1);
  },

  getInitialState: function getInitialState() {
    return {
      status: this.status,
      loggedIn: this.loggedIn,
      errors: this.errors,
      user: this.user
    };
  },

  onSubmit: function onSubmit(email, password) {
    var _this2 = this;

    this.status = 'authenticating';
    this.errors = [];

    this.trigger({
      status: this.status,
      loggedIn: this.loggedIn,
      errors: this.errors,
      user: this.user
    });

    _apiAuthentication2['default'].login(email, password).done(function (data, status, xhr) {

      _this2.status = 'authenticated';
      _this2.loggedIn = true;
      _this2.user = data;

      _this2.trigger({
        status: _this2.status,
        loggedIn: _this2.loggedIn,
        errors: _this2.errors,
        user: _this2.user
      });
    }).fail(function (xhr, status, err) {
      if (xhr.status === _apiStatus2['default'].UNAUTHORIZED) {

        _this2.status = 'failed';
        _this2.loggedIn = false;
        _this2.failed = true;
        _this2.user = null;

        _this2.trigger({
          status: _this2.status,
          loggedIn: _this2.loggedIn,
          errors: _this2.errors,
          user: _this2.user
        });
      }
    });
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/authentication.js
 **/